module.exports = __webpack_public_path__ + "static/media/company_team.46fbb8fe.jpg";